import service from '@/services/cliente/email'

const getDefaultState = () => ({
  email: {
    nombre: '',
    estado: '',
    inicio: null,
    fin: null,
    list: []
  },
  list: [],
  currentRow: null
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.email = { ...getDefaultState().email }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = obj
  },
  SET_EMAIL: (state, obj) => {
    state.email = obj
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  UNSET_EMAIL_LIST: (state, arr) => {
    state.email.list = state.email.list.filter(e => !arr.some(a => e.cliente._id === a.cliente._id))
  },
  SET_EMAIL_LIST: (state, obj) => {
    state.email.list = [...obj, ...state.email.list]
  }
}
export const actions = {
  resetList: ({ state }) => {
    state.list = []
  },
  readAllByEmisor: async ({ commit, state, rootGetters, dispatch }) => {
    // if (restart) await dispatch('resetList')

    // if (state.list.length > 0) {
    //   return true
    // }

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(response => commit('SET_LIST', response))
  },

  readById: async ({ state, commit }, { _id }) => {
    return service.readById(_id).then(response => {
      return commit('SET_EMAIL', response)
    })
  },

  create: async ({ commit, rootGetters, state }, { input }) => {
    const list = state.email.list.map(i => {
      return {
        cliente: i.cliente,
        email: i.email
      }
    })

    return service
      .create({
        ...input,
        list,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        state.email._id = result._id
        commit('UPDATE_LIST', { ...input, _id: result._id })

        return result._id
      })
  },

  deleteCliente: async ({ state, rootGetters }, { input }) => {
    return service.deleteCliente({
      // id del email a eliminar lista
      _id: state.email._id,
      emisor: {
        _id: await rootGetters['facturacion/emisorStore/get_Id']
      },
      nombre: state.email.nombre,
      list: input
    })
  }

  // delete: ({ commit }, { inputs }) =>
  //   service.delete(inputs).then(result => {
  //     result.forEach(i => {
  //       if (i.state) commit('DELETE_LIST', i)
  //     })
  //     return result
  //   })
}
